module.exports = __webpack_public_path__ + "media/stylesheets/font/summernote-b293d601cf1cddd1a1b40941d9cbd683.ttf";